
/* injects from baggage-loader */

import React, {Component} from "react";
import InputKeyboard from "../InputKeyboard";

class KeyboardForCasino extends Component {
    render () {
        return <InputKeyboard class={"input-for-casino"} setFocus={true} casino={true} key={Date.now()}/>;
    }
}
export default KeyboardForCasino;